import { CSSProperties } from "@material-ui/core/styles/withStyles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

import { baseBody } from "../SuggestionBody.styles";

export const container: CSSProperties = {
  ...baseBody,
};

export const header: CSSProperties = {
  display: "flex",
  alignItems: "center",
  marginBottom: spacing.sm,
};

export const h3: CSSProperties = {
  margin: "0 10px",
};
